import { BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { BaseOntarioObstetricalFileSubLaboratorySection } from "./BaseOntarioObstetricalFileSubLaboratorySection";

class OntarioObstetricalFileSecondThirdTrimesterLabInvestigation extends BaseOntarioObstetricalFileSubLaboratorySection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const trimesterLab = this.props.form.Opr2.SecondAndThirdTrimesterLab;

        return (
            <div className="col-md-4 border border-left padding-md-bottom">
                <div className="section">
                    {this.renderSubTitle("ObstetricalFile_SecondThirdTrimesterLabel")}
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "HemoglobinAbbreviationLabel",
                            trimesterLab.Hemoglobin,
                            value => this.props.mutateModelState(s => s.Opr2.SecondAndThirdTrimesterLab.Hemoglobin = value),
                            true
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "PlateletsLabel",
                            trimesterLab.Platelets,
                            value => this.props.mutateModelState(s => s.Opr2.SecondAndThirdTrimesterLab.Platelets = value)
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        <div className="col-md-6 flex-display">
                            {this.renderSimpleField(
                                "BloodGroupAcronymLabel",
                                this.controlRenderer.renderComboBox({
                                    id: "bloodGroup-trimesterLab",
                                    selectedCode: trimesterLab.BloodGroup,
                                    items: this.controlRenderer.getBloodGroupOptions(),
                                    onChange: bloodGroup => this.setBloodGroup(bloodGroup),
                                    hasEmptyItem: true
                                }),
                                "flex-column margin-sm-right flex-grow-1"
                            )}
                            {this.renderSimpleField(
                                "BloodRhesusAcronymLabel",
                                this.controlRenderer.renderComboBox({
                                    id: "bloodRhesus-trimesterLab",
                                    selectedCode: trimesterLab.BloodRhesus,
                                    items: this.controlRenderer.getBloodRhesusOptions(),
                                    onChange: bloodRhesus => this.setBloodRhesus(bloodRhesus),
                                    hasEmptyItem: true
                                }),
                                "flex-column flex-grow-1"
                            )}
                        </div>
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "ObstetricalFile_RepeatAntibodiesLabel",
                            trimesterLab.RepeatAntibodies,
                            value => this.props.mutateModelState(s => s.Opr2.SecondAndThirdTrimesterLab.RepeatAntibodies = value)
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "ObstetricalFile_FirstHourGlucoseChallengeTestAbbreviationLabel",
                            trimesterLab.FirstHourGlucoseChallengeTest,
                            value => this.props.mutateModelState(s => s.Opr2.SecondAndThirdTrimesterLab.FirstHourGlucoseChallengeTest = value)
                        )}
                    </div>
                    <div className="row">
                        {this.renderLaboratoryTextField(
                            "ObstetricalFile_SecondHourGlucoseToleranceTestAbbreviationLabel",
                            trimesterLab.SecondHourGlucoseToleranceTest,
                            value => this.props.mutateModelState(s => s.Opr2.SecondAndThirdTrimesterLab.SecondHourGlucoseToleranceTest = value)
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFileSecondThirdTrimesterLabInvestigation };
